var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-va",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.992 0h255.992v511.984H255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.43-735.13c0 .625 55.956 222.85 118.17 300.56 69.375 87.27 113.18 87.333 113.18 87.333l70.866-17.717s-41.496 2.093-123.8-104.21c-83.45-107.78-109.42-285.96-108.17-282.84l-70.241 16.875z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285-727.64c-1.535-9.369 33.898 220.95 140.2 327.24 53.149 53.15 88.583 53.15 88.583 53.15l88.582-17.717s-51.712 3.751-134.02-102.55c-83.45-107.78-108.58-263.25-107.96-263.87l-75.38 3.75z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.43-735.13c0 .625 55.956 222.85 118.17 300.56 69.375 87.27 113.18 87.333 113.18 87.333l70.866-17.717s-41.496 2.093-123.8-104.21c-83.45-107.78-109.42-285.96-108.17-282.84l-70.241 16.875z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285-727.64c-1.535-9.369 33.898 220.95 140.2 327.24 53.149 53.15 88.583 53.15 88.583 53.15l88.582-17.717s-51.712 3.751-134.02-102.55c-83.45-107.78-108.58-263.25-107.96-263.87l-75.38 3.75z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(.21538 .00384 -.00463 .17867 312.189 347.844)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 14.25,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01583 .00247 .00912 -.01043 340.027 336.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01553 .00281 .0093 -.0104 338.545 337.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01583 .00247 .00912 -.01043 336.674 339.094)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01606 -.001 .00564 -.01204 356.628 320.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01588 -.00034 .0061 -.01195 355.573 322.306)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01608 -.00073 .00592 -.01194 354.162 324.083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01587 .0005 .007 -.0116 353.27 324.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01584 -.00241 .00408 -.01247 360.56 315.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0157 -.002 .00426 -.0125 359.677 316.692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01584 -.00241 .00408 -.01247 358.543 318.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01575 -.00175 .00455 -.01242 357.483 319.951)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01601 .0014 .00808 -.01102 346.242 331.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01575 .00175 .00826 -.011 344.879 332.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01601 .0014 .00808 -.01102 343.153 334.224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01553 .00281 .0093 -.0104 341.9 335.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0161 .00013 .00681 -.0116 351.728 326.278)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01587 .0005 .007 -.0116 350.513 327.653)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01601 .0014 .00808 -.01102 349.33 328.537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01575 .00175 .00826 -.011 347.968 329.811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 369.31 295.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01532 -.00352 .0025 -.01283 369.285 296.24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0154 -.00394 .00232 -.01278 368.426 298.248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01532 -.00352 .0025 -.01283 367.762 299.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 371.147 289.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 370.48 291.994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 369.975 293.652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 364.29 308.35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 363.475 309.918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 362.426 311.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0157 -.002 .00426 -.0125 361.693 313.239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0154 -.00394 .00232 -.01278 366.903 301.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 367.199 302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01572 -.0029 .00353 -.01259 366.151 304.836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0156 -.00249 .0037 -.01262 365.337 306.404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01384 -.0069 -.00138 -.01288 373.984 279.81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01486 -.00518 .00082 -.01291 374.024 281.192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01483 -.00476 .00099 -.01297 373.555 282.857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01388 -.00647 -.00122 -.01295 374.695 273.862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01384 -.0069 -.00138 -.01288 374.431 275.984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01388 -.00647 -.00122 -.01295 374.248 277.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01486 -.00518 .00082 -.01291 372.934 284.926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01493 -.00453 .00126 -.01295 372.347 286.125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01497 -.00495 .0011 -.0129 371.683 288.184)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 14.25,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01599 .0016 -.00828 -.01091 422.72 331.398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01571 .00195 -.00846 -.0109 424.106 332.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01599 .0016 -.00828 -.01091 425.86 334.202)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01594 -.00187 -.00468 -.01232 407.37 315.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01582 -.00121 -.00515 -.01226 408.317 316.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01598 -.0016 -.00497 -.01224 409.586 318.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01588 -.00037 -.00607 -.01196 410.437 318.807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01562 -.00328 -.0031 -.01267 403.902 308.997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01551 -.00286 -.00327 -.0127 404.663 310.585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01562 -.00328 -.0031 -.01267 405.644 312.554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01558 -.0026 -.00357 -.01265 406.597 313.958)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 416.917 325.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01585 .00088 -.00738 -.01143 418.178 327.326)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 419.777 328.986)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01571 .00195 -.00846 -.0109 420.965 329.851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01607 -.00076 -.00589 -.01195 411.843 320.587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01588 -.00037 -.00607 -.01196 412.948 322.026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01609 .0005 -.0072 -.01144 414.058 322.973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01585 .00088 -.00738 -.01143 415.318 324.319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 396.696 289.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.015 -.00436 -.00148 -.01293 396.68 289.649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01505 -.00478 -.00131 -.01288 397.38 291.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.015 -.00436 -.00148 -.01293 397.914 293.351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 395.316 283.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 395.819 285.347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 396.193 287.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 400.715 302.006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 401.404 303.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 402.298 305.615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01551 -.00286 -.00327 -.0127 402.921 307.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01505 -.00478 -.00131 -.01288 398.614 295.403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 398.24 296.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01546 -.00376 -.00253 -.01275 399.132 298.398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01538 -.00334 -.0027 -.0128 399.822 300.008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01327 -.00764 .00239 -.01277 393.279 272.996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01443 -.00598 .0002 -.01293 393.13 274.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01443 -.00556 .00003 -.013 393.468 276.06)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01334 -.00722 .00224 -.01286 393.035 267.022)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01327 -.00764 .00239 -.01277 393.133 269.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01334 -.00722 .00224 -.01286 393.182 270.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01443 -.00598 .0002 -.01293 393.926 278.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00534 -.00025 -.013 394.417 279.387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01455 -.00577 -.00008 -.01293 394.918 281.479)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(-.21538 .00384 .00463 .17867 452.172 346.217)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.12959 0 0 .10848 351.35 305.645)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M324.546-255.37l-50.11 50.11L449.82-29.874l50.11-50.11z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff133",
    transform: "scale(-1 1) rotate(45 -177.879 -1104.595)",
    cx: 354.33,
    rx: 35.433,
    cy: -1428,
    ry: 35.433,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-402.046-956.911l37.583 37.583-25.055 25.054-37.583-37.582c-12.528-12.528 12.527-37.583 25.055-25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-346.606-926.531l-50.11 50.11c-13.798 0-25.351-11.553-25.055-25.055 10.878-25.879 25.028-38.434 50.11-50.11 12.477.729 24.217 10.892 25.055 25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351.926-931.851l37.583 37.583-50.11 50.11-37.583-37.583c5.027-20.028 30.082-45.084 50.11-50.11z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309.026-888.951l-50.11 50.11c-13.798 0-25.351-11.553-25.055-25.055 10.878-25.879 25.028-38.434 50.11-50.11 12.477.729 24.217 10.892 25.055 25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.356-894.281L28.44-551.477l-50.111 50.11-342.795-342.804c5.027-20.028 30.082-45.084 50.11-50.11z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.934-530.971l-50.11 50.11c-13.798 0-25.351-11.553-25.055-25.055 10.878-25.879 25.028-38.434 50.11-50.11 12.477.729 24.217 10.892 25.055 25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.944-530.976L274.44-305.48l-50.11 50.11L-1.166-480.866c5.027-20.028 30.082-45.084 50.11-50.11z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.744-418.231l-75.166 75.166c-13.797 0-25.35-11.553-25.055-25.055 0 0 0-25.055 25.055-50.11s50.11-25.055 50.11-25.055c11.64 1.567 21.415 12.527 25.055 25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.744-418.231l50.11 75.166-50.11 50.11-75.165-50.111c-2.83-2.442 0-25.054 25.055-50.11s48.98-24.456 50.11-25.055z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61-506.69c0-35.433 0-86.653 17.717-129.98 17.716 43.326 17.716 94.546 17.716 129.98H336.61z",
    transform: "rotate(135 434.752 18.668) scale(1 -.81782)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9-506.69h17.716v-43.326c0-43.327-35.433-64.99-35.433-64.99l17.717 108.32z",
    transform: "rotate(-45 399.396 -194.158) scale(1 .81782)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9-506.69h17.716v-43.326c0-43.327-35.433-64.99-35.433-64.99l17.717 108.32z",
    transform: "rotate(135 434.752 18.668) scale(1 -.81782)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-314.356-894.281l37.583 37.583C-251.718-831.643-164.03-718.9-164.03-718.9s117.296 92.25 142.356 117.31l37.583 37.583c-25.056-25.055-179.937-129.835-179.937-129.835S-71.784-551.479-34.2-513.896l-37.583-37.583c-25.055-25.055-117.305-142.36-117.3-142.366-.005.005-100.223-75.168-125.276-100.22l-50.111-50.111c25.055 25.055 175.382 125.281 175.382 125.281s-100.22-150.338-125.272-175.391z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.493-230.317c50.11 75.165 100.221 125.276 112.744 137.8 23.776 23.819 50.11 25.055 50.11 25.055s0-25.056-25.055-50.11c-12.527-12.528-62.638-62.639-137.8-112.745zm-62.64-112.75c87.695 87.695 187.916 137.806 250.552 200.442 50.11 50.11 15.414 88.464 1.443 100.606-13.97 12.141-51.966 50.282-101.664-.386-62.638-62.638-112.746-162.857-200.442-250.552 0-25.055 25.056-50.11 50.11-50.11z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.2487 -1.4214 -1.3593 1.3175 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver",
    d: "M218.28 257.88h22.934v73.043H218.28z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "silver"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.18 396.85l17.717 17.717-17.717 17.716 8.858 8.859 17.717-17.717 35.433 35.433-17.717 17.717 8.859 8.858 17.716-17.716 17.717 17.716-53.15 53.15-35.433-35.433 17.717-17.717 8.858 8.859 8.858-8.859L301.18 450l-8.858 8.859 8.858 8.858-17.716 17.716-17.717-17.716 8.858-8.859-8.858-8.858-35.433 35.433 8.858 8.858 8.858-8.858 17.717 17.717-17.716 17.716-8.858-8.858-8.859 8.858 35.433 35.433 8.859-8.858-8.859-8.859 17.717-17.716 35.433 35.433-53.15 53.15-17.717-17.717 17.717-17.716-8.858-8.858-17.717 17.716-35.433-35.433 17.717-17.717-8.859-8.858-17.716 17.717-17.717-17.717 124.02-124.02z",
    transform: "matrix(-2.2946 0 0 2.2438 360.577 -1733.726)",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.61v35.433l88.582 88.583V839.76l-17.716-17.717h-35.433L318.9 786.61z",
    strokeWidth: 1.25,
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.78l70.381 70.381.838 35.19-71.219-71.219V698.78z",
    transform: "matrix(-1.1473 0 0 1.1219 157.424 -1288.525)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    strokeWidth: 1.25,
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 258.941 -1387.881)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    strokeWidth: 1.25,
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    transform: "matrix(-1.1473 0 0 1.1219 55.679 -1189.119)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.78l35.786 35.433v35.433l-35.786-36.514V698.78z",
    transform: "matrix(-1.1473 0 0 1.1219 218.806 -1348.97)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 55.679 -1507.136)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 136.983 -1427.638)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 822.05l53.15-53.15v-35.433l-70.866 70.866 17.716 17.717z",
    transform: "matrix(-1.1473 0 0 1.1219 136.983 -1546.896)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    transform: "matrix(-1.1473 0 0 1.1219 35.352 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-35.433-35.433v-35.433l35.433 35.433v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 55.679 -1507.136)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 822.05l-53.15-53.15v-35.433l70.866 70.866-17.716 17.717z",
    transform: "matrix(-1.1473 0 0 1.1219 55.679 -1546.896)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.05l70.866 70.866h35.433l17.717 17.716v70.867l-124.02-124.37v-35.08z",
    transform: "matrix(-1.1473 0 0 1.1219 -66.161 -1387.906)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33 822.05l106.3-106.3h35.433l-106.3 106.3H354.33z",
    strokeWidth: 1.25,
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76l106.3-106.3-17.72-17.71-106.3 106.3 17.72 17.71z",
    strokeWidth: 1.25,
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76v70.866l106.3-106.3V733.46l-106.3 106.3z",
    transform: "matrix(-1.1473 0 0 1.1219 157.31 -1288.5)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33 822.05l106.3-106.3h35.433l-106.3 106.3H354.33z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.297 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76l106.3-106.3-17.72-17.71-106.3 106.3 17.72 17.71z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.297 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76v70.866l106.3-106.3V733.46l-106.3 106.3z",
    transform: "matrix(-1.1473 0 0 1.1219 -5.297 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.62l17.717-17.717V733.47l-35.433 35.433L318.9 786.62z",
    transform: "matrix(-1.1473 0 0 1.1219 -86.606 -1527.016)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.62l17.717-17.717V733.47l-35.433 35.433L318.9 786.62z",
    transform: "matrix(-1.1473 0 0 1.1219 15.022 -1626.394)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 768.9v-35.433l17.717 17.716L265.75 768.9z",
    transform: "matrix(-1.1473 0 0 1.1219 55.679 -1348.129)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-35.433-35.433 17.717-17.717 17.716 17.717v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 136.983 -1427.638)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-17.716-17.717 17.716-17.716v35.433z",
    transform: "matrix(-1.1473 0 0 1.1219 15.022 -1586.645)",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.2509 -1.4194 -1.3614 1.3153 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133",
    d: "M196.5 254.15h25.197v80.26H196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61 166.54c0 14.669 35.433 35.434 35.433-17.716H336.61v17.716z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1 24.803c-147.06 0-113.13 164.24-100.37 124.02 9.359-29.503 35.433-70.866 64.935-80.225 40.225-12.761 26.696 9.359 41.364 9.359 14.67 0 1.14-22.12 41.364-9.359 29.503 9.359 55.577 50.722 64.936 80.225 12.76 40.224 53.149-124.02-112.23-124.02z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 166.54c0 78.237-63.496 141.73-141.73 141.73-78.236 0-141.73-63.496-141.73-141.73v-17.716c.001-29.116 35.433 124.02 141.73 124.02s141.73-124.77 141.73-124.02v17.716z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61 166.54c0 14.669 35.433 35.434 35.433-17.716H336.61v17.716z",
    transform: "matrix(1.8992 0 0 1.8865 224 -100.51)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 148.82c0 78.236-63.496 141.73-141.73 141.73-78.236 0-141.73-63.496-141.73-141.73 0-78.236 63.496-141.73 141.73-141.73 78.237 0 141.73 63.496 141.73 141.73zm-53.15 0c0 14.669 22.812 3.042 9.359 43.04-9.359 27.826-27.075 45.543-56.578 54.902-40.225 12.76-26.694-9.359-41.364-9.359-14.668 0-1.14 22.119-41.364 9.359-29.502-9.359-47.218-27.076-56.577-56.578-12.76-40.224 9.359-26.695 9.359-41.364 0-14.67-22.119-1.139-9.359-41.364 9.359-29.502 27.075-47.219 56.577-56.578 40.225-12.761 26.696 9.359 41.364 9.359 14.67 0 1.14-22.12 41.364-9.359 29.503 9.359 47.219 27.075 56.578 56.578 12.76 40.224-9.359 26.694-9.359 41.364z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55 157.68c-20.248 0-1.929 67.6-9.104 51.705s-11.144-33.368-11.144-51.705 3.969-35.809 11.144-51.705c7.175-15.894-11.144 51.705 9.104 51.705z",
    transform: "matrix(-1.6618 0 0 1.7607 1107.2 -99.519)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05 139.96c0 15.892-2.13 31.632-9.751 44.811-7.965 13.775 9.751-44.811-7.965-44.811 17.716 0 1.687-58.587 7.965-44.811 6.279 13.776 9.751 28.919 9.751 44.811z",
    transform: "matrix(-1.8992 0 0 2.0316 1166.1 -106.24)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29 263.08c-14.836 6.279-31.144 9.751-48.258 9.751s-33.422-3.472-48.257-9.751c-14.835-6.278 48.257 9.751 48.257-7.966 0 17.717 63.093 1.688 48.258 7.966zM248.03 42.52c0-17.716-63.092-1.688-48.257-7.966s31.143-9.75 48.257-9.75 33.422 3.472 48.258 9.75c14.835 6.278-48.258-9.75-48.258 7.966z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff133",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1257.6 -120.02)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(-1.2929 -1.3819 1.3912 -1.2842 808.89 712.05)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.88)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7 308.51c-9.223 1.889-20.189.927-29.969.927-9.778 0-19.285-2.612-28.509-4.501l8.821-10.303c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025L267.7 308.51z",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.88)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 847.44 -345.21)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff133",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 789.14 314.38)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59 281.47c-9.223 1.889-17.098 2.943-26.877 2.943s-23.112-.712-32.336-2.601l9.672 12.822c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025L267.59 281.47z",
    transform: "matrix(-1.3912 1.2842 1.2929 1.3819 850.63 -315.18)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.94 271.77l-.838 14.842-3.239 4.493.976-15.087 3.101-4.248zm156.6-6.17l3.562 4.189 1.047 13.616-2.933-2.933-1.676-14.872z",
    transform: "matrix(-1.8992 0 0 1.8865 1166.1 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff133",
    transform: "matrix(-1.2929 -1.3819 -1.3912 1.2842 1237.6 329.88)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M513.78-790.16l35.432-17.714 35.433 17.714s-73.366 35.433-73.366 159.45c-.001 88.58 125.26 106.3 125.26 212.6 0 45.649-34.183 88.582-69.616 88.582s-88.583-17.716-141.73-70.866c35.433 17.716 76.082 37.308 106.3 36.058 19.588-.405 55.025-17.716 55.025-53.149 0-70.866-122.77-106.92-122.77-213.22 0-124.02 50.025-159.45 50.026-159.45z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.25-790.16l46.683-17.717 10 17.717s-70.649 35.433-70.649 159.45c-.001 88.58 125.89 106.3 125.89 212.6 0 45.649-26.714 87.362-65.241 88.582-73.403 2.363-90.458-23.966-141.73-70.866 43.149 32.308 105 46.752 129.02 34.183 29.354-15.364 35.024-36.058 35.024-53.774 0-70.866-120.89-104.42-120.89-210.72 0-124.02 51.9-159.45 51.9-159.45z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.34-789.69c7.004-2.437 35.875-18.186 71.308 17.247 17.717 17.72 17.716 53.149 17.716 70.866l53.15-53.149s-29.066-86.87-107.62-53.592c-11.127 4.901-28.139 14.538-34.549 18.628z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8-795.94c8.839-2.869 36.676-6.325 64.596 18.501 17.717 17.72 18.966 42.933 18.966 60.65l40.65-37.933c3.44-3.21-24.832-81.252-99.241-54.034-4.498 1.807-14.779 6.302-24.971 12.816z",
    transform: "matrix(-.21542 0 0 .17871 450.486 340.71)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(-.17534 -.01853 -.05985 .15541 365.625 343.191)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(.15954 .02165 .00278 -.11904 258.866 126.07)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.12959 0 0 .10848 351.35 305.645)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    transform: "rotate(45 478.12 -504.573)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "silver",
    transform: "translate(124.01 283.46)",
    cx: 354.33,
    rx: 35.433,
    cy: -1428,
    ry: 35.433,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.63-1126.77v53.15h35.432l.001-53.15c0-17.717-35.433-17.717-35.433 0z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91-1066.09h70.866c9.757-9.756 9.757-26.095 0-35.433-25.991-10.607-44.874-9.48-70.866 0-8.307 9.338-9.422 24.826 0 35.433z",
    stroke: "#000",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91-1073.62v53.15h70.866v-53.15c-17.717-10.607-53.15-10.607-70.866 0z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91-1012.94h70.866c9.757-9.756 9.757-26.095 0-35.433-25.991-10.607-44.874-9.48-70.866 0-8.307 9.338-9.422 24.826 0 35.433z",
    stroke: "#000",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff133",
    d: "M442.91-116.93h70.866V131.1H442.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91-1020.476l.006 484.79h70.867l-.007-484.79c-17.717-10.607-53.15-10.607-70.866 0z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92-506.698h70.866c9.757-9.756 9.757-26.095 0-35.433-25.991-10.607-44.874-9.48-70.866 0-8.307 9.338-9.422 24.826 0 35.433z",
    stroke: "#000",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92-506.7v318.9h70.866v-318.9c-17.717-10.607-53.15-10.607-70.866 0z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19-329.53h106.3c9.757-9.756 9.757-26.095 0-35.433 0 0-17.716-17.716-53.149-17.716s-53.15 17.716-53.15 17.716c-7.122 9.338-6.284 24.001 0 35.433z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19-329.53l17.717 88.583h70.866l17.716-88.583c.274-3.727-17.716-17.716-53.149-17.716s-51.928 17.341-53.15 17.716z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61-506.69c0-35.433 0-86.653 17.717-129.98 17.716 43.326 17.716 94.546 17.716 129.98H336.61z",
    transform: "matrix(1 0 0 .81782 124.01 173.44)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9-506.69h17.716v-43.326c0-43.327-35.433-64.99-35.433-64.99l17.717 108.32z",
    transform: "matrix(-1 0 0 .81782 832.67 173.44)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9-506.69h17.716v-43.326c0-43.327-35.433-64.99-35.433-64.99l17.717 108.32z",
    transform: "matrix(1 0 0 .81782 124.01 173.44)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.34-116.93c17.716 88.582 17.716 159.45 17.716 177.16.031 33.655-17.716 53.15-17.716 53.15s-17.717-17.717-17.717-53.15c0-17.716 0-88.583 17.717-177.16zm-35.433-124.02c0 124.02-35.433 230.32-35.433 318.9 0 70.866 51.654 73.453 70.118 72.16 18.464-1.294 72.3-1.191 71.614-72.16 0-88.583-35.433-194.88-35.433-318.9-17.717-17.716-53.15-17.716-70.866 0z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91-1020.476v53.15c0 35.433 17.716 177.16 17.716 177.16s-17.71 148.17-17.71 183.61v53.15c0-35.433 35.427-219.04 35.427-219.04s35.44 165.89 35.44 219.04v-53.15c0-35.433-17.717-183.61-17.724-183.61.007 0 17.717-124.02 17.717-159.45v-70.867c0 35.433-35.426 212.6-35.426 212.6s-35.44-177.17-35.44-212.6z",
    stroke: "#000",
    fill: "silver"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.2487 -1.4214 1.3593 1.3175 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133",
    d: "M218.28 257.88h22.934v73.043H218.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61 166.54c0 14.669 35.433 35.434 35.433-17.716H336.61v17.716z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1 24.803c-147.06 0-113.13 164.24-100.37 124.02 9.359-29.503 35.433-70.866 64.935-80.225 40.225-12.761 26.696 9.359 41.364 9.359 14.67 0 1.14-22.12 41.364-9.359 29.503 9.359 55.577 50.722 64.936 80.225 12.76 40.224 53.149-124.02-112.23-124.02z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 166.54c0 78.237-63.496 141.73-141.73 141.73-78.236 0-141.73-63.496-141.73-141.73v-17.716c.001-29.116 35.433 124.02 141.73 124.02s141.73-124.77 141.73-124.02v17.716z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "silver",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -753.9 -120.02)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.2509 -1.4194 1.3614 1.3153 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver",
    d: "M196.5 254.15h25.197v80.26H196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.61 166.54c0 14.669 35.433 35.434 35.433-17.716H336.61v17.716z",
    transform: "matrix(-1.8992 0 0 1.8865 279.67 -100.51)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 148.82c0 78.236-63.496 141.73-141.73 141.73-78.236 0-141.73-63.496-141.73-141.73 0-78.236 63.496-141.73 141.73-141.73 78.237 0 141.73 63.496 141.73 141.73zm-53.15 0c0 14.669 22.812 3.042 9.359 43.04-9.359 27.826-27.075 45.543-56.578 54.902-40.225 12.76-26.694-9.359-41.364-9.359-14.668 0-1.14 22.119-41.364 9.359-29.502-9.359-47.218-27.076-56.577-56.578-12.76-40.224 9.359-26.695 9.359-41.364 0-14.67-22.119-1.139-9.359-41.364 9.359-29.502 27.075-47.219 56.577-56.578 40.225-12.761 26.696 9.359 41.364 9.359 14.67 0 1.14-22.12 41.364-9.359 29.503 9.359 47.219 27.075 56.578 56.578 12.76 40.224-9.359 26.694-9.359 41.364z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55 157.68c-20.248 0-1.929 67.6-9.104 51.705s-11.144-33.368-11.144-51.705 3.969-35.809 11.144-51.705c7.175-15.894-11.144 51.705 9.104 51.705z",
    transform: "matrix(1.6618 0 0 1.7607 -603.57 -99.519)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05 139.96c0 15.892-2.13 31.632-9.751 44.811-7.965 13.775 9.751-44.811-7.965-44.811 17.716 0 1.687-58.587 7.965-44.811 6.279 13.776 9.751 28.919 9.751 44.811z",
    transform: "matrix(1.8992 0 0 2.0316 -662.45 -106.24)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29 263.08c-14.836 6.279-31.144 9.751-48.258 9.751s-33.422-3.472-48.257-9.751c-14.835-6.278 48.257 9.751 48.257-7.966 0 17.717 63.093 1.688 48.258 7.966zM248.03 42.52c0-17.716-63.092-1.688-48.257-7.966s31.143-9.75 48.257-9.75 33.422 3.472 48.258 9.75c14.835 6.278-48.258-9.75-48.258 7.966z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(1.2929 -1.3819 -1.3912 -1.2842 -305.22 712.05)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.56 329.88)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.7 308.51c-9.223 1.889-20.189.927-29.969.927-9.778 0-19.285-2.612-28.509-4.501l8.821-10.303c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025L267.7 308.51z",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -719.56 329.88)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.58 287.67c-9.223 1.889-18.773 2.881-28.552 2.881s-19.329-.992-28.553-2.881l-1.432 6.965c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025l-1.433-6.965z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -343.78 -345.21)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "silver",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -285.47 314.38)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59 281.47c-9.223 1.889-17.098 2.943-26.877 2.943s-23.112-.712-32.336-2.601l9.672 12.822c9.686 1.984 19.715 3.025 29.985 3.025s20.299-1.041 29.985-3.025L267.59 281.47z",
    transform: "matrix(1.3912 1.2842 -1.2929 1.3819 -346.96 -315.18)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.94 271.77l-.838 14.842-3.239 4.493.976-15.087 3.101-4.248zm156.6-6.17l3.562 4.189 1.047 13.616-2.933-2.933-1.676-14.872z",
    transform: "matrix(1.8992 0 0 1.8865 -662.45 -102.64)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "silver",
    transform: "matrix(1.2929 -1.3819 1.3912 1.2842 -733.89 329.88)",
    cx: 82.112,
    rx: 18.433,
    cy: 160.86,
    ry: 20.109,
    stroke: "#000",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#fff133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.18 396.85l17.717 17.717-17.717 17.716 8.858 8.859 17.717-17.717 35.433 35.433-17.717 17.717 8.859 8.858 17.716-17.716 17.717 17.716-53.15 53.15-35.433-35.433 17.717-17.717 8.858 8.859 8.858-8.859L301.18 450l-8.858 8.859 8.858 8.858-17.716 17.716-17.717-17.716 8.858-8.859-8.858-8.858-35.433 35.433 8.858 8.858 8.858-8.858 17.717 17.717-17.716 17.716-8.858-8.858-8.859 8.858 35.433 35.433 8.859-8.858-8.859-8.859 17.717-17.716 35.433 35.433-53.15 53.15-17.717-17.717 17.717-17.716-8.858-8.858-17.717 17.716-35.433-35.433 17.717-17.717-8.859-8.858-17.716 17.717-17.717-17.717 124.02-124.02z",
    transform: "matrix(2.2946 0 0 2.2438 143.093 -1733.726)",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.61v35.433l88.582 88.583V839.76l-17.716-17.717h-35.433L318.9 786.61z",
    strokeWidth: 1.25,
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.78l70.381 70.381.838 35.19-71.219-71.219V698.78z",
    transform: "matrix(1.1473 0 0 1.1219 346.246 -1288.525)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    strokeWidth: 1.25,
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 244.729 -1387.881)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    strokeWidth: 1.25,
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    transform: "matrix(1.1473 0 0 1.1219 447.991 -1189.119)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.78l35.786 35.433v35.433l-35.786-36.514V698.78z",
    transform: "matrix(1.1473 0 0 1.1219 284.864 -1348.97)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 447.991 -1507.136)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l35.433-35.433v-35.433l-35.433 35.433v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 366.687 -1427.638)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46 822.05l53.15-53.15v-35.433l-70.866 70.866 17.716 17.717z",
    transform: "matrix(1.1473 0 0 1.1219 366.687 -1546.896)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.03 644.88v35.433l17.717-17.717-17.717-17.716z",
    transform: "matrix(1.1473 0 0 1.1219 468.318 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-35.433-35.433v-35.433l35.433 35.433v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 447.991 -1507.136)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76 822.05l-53.15-53.15v-35.433l70.866 70.866-17.716 17.717z",
    transform: "matrix(1.1473 0 0 1.1219 447.991 -1546.896)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41 698.05l70.866 70.866h35.433l17.717 17.716v70.867l-124.02-124.37v-35.08z",
    transform: "matrix(1.1473 0 0 1.1219 569.831 -1387.906)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33 822.05l106.3-106.3h35.433l-106.3 106.3H354.33z",
    strokeWidth: 1.25,
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76l106.3-106.3-17.72-17.71-106.3 106.3 17.72 17.71z",
    strokeWidth: 1.25,
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76v70.866l106.3-106.3V733.46l-106.3 106.3z",
    transform: "matrix(1.1473 0 0 1.1219 346.36 -1288.5)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33 822.05l106.3-106.3h35.433l-106.3 106.3H354.33z",
    transform: "matrix(1.1473 0 0 1.1219 508.967 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76l106.3-106.3-17.72-17.71-106.3 106.3 17.72 17.71z",
    transform: "matrix(1.1473 0 0 1.1219 508.967 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 839.76v70.866l106.3-106.3V733.46l-106.3 106.3z",
    transform: "matrix(1.1473 0 0 1.1219 508.967 -1447.507)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.62l17.717-17.717V733.47l-35.433 35.433L318.9 786.62z",
    transform: "matrix(1.1473 0 0 1.1219 590.276 -1527.016)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.9 786.62l17.717-17.717V733.47l-35.433 35.433L318.9 786.62z",
    transform: "matrix(1.1473 0 0 1.1219 488.648 -1626.394)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75 768.9v-35.433l17.717 17.716L265.75 768.9z",
    transform: "matrix(1.1473 0 0 1.1219 447.991 -1348.129)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-35.433-35.433 17.717-17.717 17.716 17.717v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 366.687 -1427.638)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18 804.33l-17.716-17.717 17.716-17.716v35.433z",
    transform: "matrix(1.1473 0 0 1.1219 488.648 -1586.645)",
    strokeWidth: 1.25
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.865 291.272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.899 289.563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.905 287.429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.938 285.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.786 298.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.82 297.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.826 295.116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.859 293.406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 377.024 275.898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377.058 274.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 377.064 272.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377.097 270.345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.945 283.586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.978 281.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.984 279.742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 377.018 278.032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.548 322.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.581 320.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.587 318.177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.62 316.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.468 329.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.502 327.997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.508 325.864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.541 324.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.706 306.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.74 304.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.746 302.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.78 301.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.627 314.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.66 312.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.667 310.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.7 308.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.23 352.768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.263 351.058)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.27 348.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.303 347.214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.184 358.745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.19 356.611)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.224 354.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.389 337.394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.422 335.684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.428 333.551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.462 331.84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.31 345.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.343 343.371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.349 341.237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.382 339.528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.03 372.083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.064 370.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.07 368.24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.103 366.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 375.984 378.06)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 375.99 375.926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.024 374.217)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.11 364.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01298 .00767 -.00286 .01277 376.143 362.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01288 .00808 -.003 .01268 376.15 360.553)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.502 291.523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.512 289.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.49 287.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.5 285.969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.526 299.21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.537 297.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.514 295.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.524 293.656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.454 276.149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.464 274.439)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.441 272.305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.452 270.595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.478 283.836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.488 282.126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.466 279.992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.476 278.282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.599 322.272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.61 320.562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.587 318.428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.597 316.718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.623 329.959)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.633 328.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.61 326.116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.621 324.406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.55 306.898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.56 305.187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.538 303.054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.549 301.344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.575 314.585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.585 312.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.562 310.741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.573 309.031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.695 353.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.706 351.311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.683 349.177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.694 347.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.73 358.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.708 356.864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.718 355.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.647 337.647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.658 335.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.635 333.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.645 332.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.671 345.334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.682 343.624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.66 341.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.67 339.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.756 372.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.767 370.626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.744 368.494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.755 366.783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.79 378.314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.768 376.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.779 374.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.732 364.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01308 .00754 -.00269 .0128 379.742 362.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.013 .00796 -.00283 .0127 379.72 360.806)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 14.25,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0162 .00404 .00232 .0128 389.98 279.749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0045 .013 -.01229 .00849 386.734 276.387)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01181 .00968 -.00565 .01213 387.953 278.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00986 .01097 -.01604 -.00222 386.414 273.194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 .01104 -.01615 -.0021 388.57 273.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 376.989 273.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00985 .01076 -.01604 -.00257 379.142 273.172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 381.83 273.206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 .01104 -.01615 -.0021 383.728 273.238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01037 .01067 -.01593 -.0027 373.879 272.305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01138 .00976 -.01555 -.00406 375.38 272.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01504 .00625 -.01305 -.00773 374.52 271.243)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 14.25,
    fill: "#b00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 420.69 360.355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 422.629 359.816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 425.059 359.172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 426.997 358.632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01559 .00255 -.00363 .01263 441.392 352.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0103 .01036 .00644 .01175 443.264 346.973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0157 .00296 -.00345 .0126 442.428 350.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01221 -.00878 -.01414 .0052 411.602 362.163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01175 -.00895 -.01428 .0051 413.589 361.766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0134 -.00747 -.01328 .0066 416.703 361.233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01125 -.00939 -.01454 .00455 417.48 360.627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01307 -.00787 -.01355 .0062 429.427 357.987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01263 -.00807 -.0137 .00611 431.366 357.448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 382.84 363.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 384.882 363.734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 387.43 363.699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 389.473 363.647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 373.66 363.964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 375.702 363.911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 378.25 363.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 380.292 363.823)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01117 -.0097 -.01466 .00406 401.87 363.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01105 -.00955 -.01463 .00433 404.145 363.136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01153 -.0094 -.0145 .00444 406.661 362.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01175 -.00895 -.01428 .0051 409.116 362.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 392.02 363.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01015 -.01023 -.01499 .00338 394.405 363.598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01123 -.00966 -.01464 .00412 397.255 363.528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00994 -.01037 -.01505 .00317 398.881 363.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 345.114 362.083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 347.134 362.338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 350.207 363.005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 352.247 363.086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 338.064 361.134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 340.579 361.481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00689 -.01198 -.01552 .00025 342.6 361.736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 363.96 363.635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 366.001 363.715)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00984 -.01067 -.0151 .0027 369.07 364.052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00934 -.01075 -.01521 .00257 371.11 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 354.791 363.215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 356.832 363.295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00882 -.01127 -.0153 .00171 359.376 363.424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00832 -.01133 -.0154 .00158 361.417 363.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01592 -.00203 .00451 -.01237 330.01 344.511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01266 -.00804 -.00338 -.01268 327.541 348.142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0085 -.01144 -.0083 -.0109 327.401 351.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.00338 -.013 -.01242 -.0078 328.048 354.944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01585 .00085 .00735 -.01145 335.005 339.412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01609 .00047 .00716 -.01145 333.41 341.077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01577 -.00162 .0047 -.01239 331.209 342.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0009 -.01346 -.01428 -.00493 329.892 357.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.00393 -.01288 -.01527 -.00232 332.543 359.562)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.0074 -.01197 -.01544 .00039 335.928 360.864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01563 -.00324 -.00984 .00997 434.886 356.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01507 -.0042 -.0106 .0095 435.015 356.672)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01583 -.00244 -.0091 .01045 439.374 354.194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(-.01496 -.00447 -.01083 .0093 436.607 355.586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01467 -.00556 .01183 .00831 430.23 346.693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01428 -.00583 .012 .00825 428.456 345.846)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01514 -.0046 .01102 .00905 425.65 344.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01428 -.00583 .012 .00825 436.466 349.605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01467 -.00556 .01183 .00831 434.236 348.574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01428 -.00583 .012 .00825 432.46 347.726)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    transform: "matrix(.07228 0 0 .0858 364.627 299.181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.603-1994.912v53.15h-53.15v35.44h53.15v106.3h35.433v-106.3h53.149v-35.44h-53.149v-53.15h-35.433z",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff133",
    transform: "matrix(.57143 0 0 .61816 93.645 -678.94)",
    cx: 239.17,
    rx: 62.008,
    cy: -1813.5,
    ry: 57.32,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.36-1119.4c0 68.45-10.417 145.68-29.252 205.02-120.08-26.455-268.06-39.682-339.04-39.682-87.586 0-246.15 13.227-345.26 26.455-18.835-59.336-30.538-123.34-30.538-191.79 0-273.81 105.27-390.21 367.5-496.03 233.3 105.82 376.6 222.22 376.6 496.03z",
    transform: "matrix(1.0576 0 0 1.3394 -5.764 363.72)",
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.1715 0 0 .74463 -32.833 -634.89)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#fff133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.32-825.59l-53.15 53.15 35.433 35.433-17.716 17.717-35.433-35.433-53.15 53.149 53.15 53.15 35.433-35.433 17.716 17.716v53.15h35.433v-53.15l17.717-17.716 35.433 35.433 53.15-53.15-53.15-53.149-35.433 35.433-17.717-17.717 35.434-35.433-53.15-53.15z",
    transform: "matrix(1.1725 0 0 .74463 -33.06 -766.809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.13516 -.18643 .29356 .72091 -190.034 -703.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.1416 .16986 -.26746 .725 182.2 -778.388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.92597 -.09509 .18717 .73508 28.799 -521.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.92699 .091 -.17909 .7359 124.84 -554.076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.1725 0 0 .74463 -33.06 -674.46)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.0735 0 0 .74463 -9.254 -386.86)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#fff133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.32-825.59l-53.15 53.15 35.433 35.433-17.716 17.717-35.433-35.433-53.15 53.149 53.15 53.15 35.433-35.433 17.716 17.716v53.15h35.433v-53.15l17.717-17.716 35.433 35.433 53.15-53.15-53.15-53.149-35.433 35.433-17.717-17.717 35.434-35.433-53.15-53.15z",
    transform: "matrix(1.1042 0 0 .74463 -12.892 -518.779)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.06903 -.18643 .27645 .72092 -160.715 -455.607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.0751 .16986 -.25188 .725 189.828 -530.358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.87203 -.09509 .17626 .73508 45.363 -273.87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.873 .091 -.16866 .7359 135.81 -306.046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.1042 0 0 .74463 -12.892 -426.43)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.105 0 0 .74463 -16.106 -865.2)",
    stroke: "#000",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "#fff133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.32-825.59l-53.15 53.15 35.433 35.433-17.716 17.717-35.433-35.433-53.15 53.149 53.15 53.15 35.433-35.433 17.716 17.716v53.15h35.433v-53.15l17.717-17.716 35.433 35.433 53.15-53.15-53.15-53.149-35.433 35.433-17.717-17.717 35.434-35.433-53.15-53.15z",
    transform: "matrix(1.0799 0 0 .70238 -6.168 -1031.347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.0455 -.17585 .27037 .68 -150.745 -971.771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.98-825.59l-8.379 53.15v35.433l-17.716 17.717v-35.434l-17.717 53.15 17.717 53.149v-35.432l17.716 17.716v53.15l17.717-.001v-53.15l17.717-17.716-.001 35.432 17.717-53.149-17.717-53.15.001 35.434-17.717-17.717v-35.433l-9.338-53.149z",
    transform: "matrix(1.05143 .16022 -.24634 .68386 192.097 -1042.283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.85284 -.0897 .17238 .69338 50.806 -800.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73-1020.5c0-17.72 17.717-35.44 35.433-35.44 17.717 0 35.433 17.72 35.433 35.44s-17.716 35.431-17.716 35.431l70.866 70.866h-35.433l-53.15-53.15-53.149 53.15H88.581l70.866-70.866s-17.717-17.711-17.717-35.431z",
    transform: "matrix(.85378 .08583 -.16494 .69414 139.262 -830.684)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.93-657.28c0-44.007-150.8-79.724-336.61-79.724s-336.61 35.717-336.61 79.724v26.575c0-44.007 150.8-70.866 336.61-70.866s336.61 44.576 336.61 88.583v-44.292z",
    transform: "matrix(1.0799 0 0 .70238 -6.168 -944.238)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#b90000",
    transform: "matrix(.96627 0 0 .41385 12.936 -517.53)",
    cx: 234.13,
    rx: 375.87,
    cy: -822.11,
    ry: 120.53
  })), /*#__PURE__*/React.createElement("path", {
    d: "M513.78-790.16l35.432-17.714 35.433 17.714s-73.366 35.433-73.366 159.45c-.001 88.58 125.26 106.3 125.26 212.6 0 45.649-34.183 88.582-69.616 88.582s-88.583-17.716-141.73-70.866c35.433 17.716 76.082 37.308 106.3 36.058 19.588-.405 55.025-17.716 55.025-53.149 0-70.866-122.77-106.92-122.77-213.22 0-124.02 50.025-159.45 50.026-159.45z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01859 -.00133 .0085 .02009 378.938 385.27)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.25-790.16l46.683-17.717 10 17.717s-70.649 35.433-70.649 159.45c-.001 88.58 125.89 106.3 125.89 212.6 0 45.649-26.714 87.362-65.241 88.582-73.403 2.363-90.458-23.966-141.73-70.866 43.149 32.308 105 46.752 129.02 34.183 29.354-15.364 35.024-36.058 35.024-53.774 0-70.866-120.89-104.42-120.89-210.72 0-124.02 51.9-159.45 51.9-159.45z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.34-789.69c7.004-2.437 35.875-18.186 71.308 17.247 17.717 17.72 17.716 53.149 17.716 70.866l53.15-53.149s-29.066-86.87-107.62-53.592c-11.127 4.901-28.139 14.538-34.549 18.628z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8-795.94c8.839-2.869 36.676-6.325 64.596 18.501 17.717 17.72 18.966 42.933 18.966 60.65l40.65-37.933c3.44-3.21-24.832-81.252-99.241-54.034-4.498 1.807-14.779 6.302-24.971 12.816z",
    transform: "matrix(.21542 0 0 .17871 313.875 342.337)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(.17534 -.01853 .05985 .15541 398.736 344.82)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54-596.29l9.152 22.141s1.455-9.767 8.526-11.534l7.071-1.768s26.864 49.328 32.168 58.167c5.302 8.838-3.536 16.793-1.769 16.793 1.769 0 26.517-11.49 26.517-11.49s-10.606.883-15.026-6.188-34.819-59.934-34.819-59.934 6.187-2.652 11.49-5.303c5.304-2.652 10.607 7.955 10.607 7.955l-13.258-26.517s0 8.839-4.42 10.607c-4.419 1.767-7.955 3.535-7.955 3.535s-3.535-6.187-7.955-13.258c-4.419-7.071 4.42-14.142 4.42-14.142l-22.981 11.49s7.955 4.42 10.607 8.839l5.303 8.839s-3.223 1.768-8.214 3.482c-3.589 1.875-7.696.054-9.464-1.714z",
    transform: "matrix(-.15954 .02165 -.00278 -.11904 505.5 127.698)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.01859 -.00133 .0085 .02009 382.077 385.078)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0313 -.00133 .01432 .02009 377.403 387.717)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0313 -.00133 .01432 .02009 380.366 387.526)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0388 -.00133 .01775 .02009 376.22 390.533)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6-453.54c-35.433 0-70.866 35.433-70.866 70.866s35.433 70.866 70.866 70.866h194.88c35.433 0 70.866-35.433 70.866-70.866 0-37.027-35.433-70.866-70.866-70.866H212.6z",
    transform: "matrix(.0388 -.00133 .01775 .02009 379.893 390.342)",
    stroke: "#000",
    strokeWidth: 20.006,
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "M0 0h255.992v511.984H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.8a8af6adf7ed744e79d85e0cdc50d3a3.svg";
export { ForwardRef as ReactComponent };